import { Button, ButtonProps } from '../button/button';

export const EmptyStateSecondaryAction = (props: ButtonProps) => (
  <Button variant="ghost" size="small" {...props} />
);
